import OnlyStarter from './components/OnlyStarter';


app.initializers.add('swaggymacro', () => {
  OnlyStarter();
});
